var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-flip"},[_c('div',{staticClass:"circle",style:(_vm.circleStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }